<button
  class="AmCalendarItem"
  [disabled]="objCalendar.disabled"
  [ngClass]="{'AmCalendarItem-currentDay': objCalendar.selected }"
  (click)="onSelect(objCalendar)"
>
  <span class="AmCalendarItem-number fs-24px fw-medium-x">
    {{ objCalendar.date.toDate() | date: 'd' }}
  </span>
  <img
    alt="arrow"
    class="AmCalendarItem-arrow"
    src="../../../../../assets/images/arrowTrip.svg"
    *ngIf="objCalendar.selected"
  />
</button>